import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */

export const getSettlementsByEvent = async (eventId) => {
  const response = await api.get(
    `api/v1/events/${eventId}/settlements/`
  );
  return response.data;
};

export const updateSettlementSetting = async (eventId, payload) => {
  const res = await api.patch(`api/v1/events/${eventId}/settlement-setting/`, payload);
  return res.data;
};

export const markPaidSettlement = async (id, payload) => {
  const res = await api.post(`api/v1/settlements/${id}/mark-paid/`, payload);
  return res.data;
};

export const cancelSettlement = async (id) => {
  await api.post(`api/v1/settlements/${id}/cancel/`);
};

export const createManualSettlement = async (eventId, payload) => {
  const res = await api.post(`api/v1/events/${eventId}/create-settlement/`);
  return res.data;
};